import { Color } from '@tmh-website/shared/colors';
import transparentize from 'polished/lib/color/transparentize';
import styled from 'styled-components';

export const Container = styled.div<{ ref: any }>`
  position: relative;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  touch-action: pan-y;
`;

interface FadeProps {
  $position: 'left' | 'right';
  $fadeColor: Color;
  $isVisible: boolean;
}

export const Fade = styled.div<FadeProps>`
  position: absolute;
  top: 0;
  z-index: 2;
  width: 20px;
  height: 100%;
  pointer-events: none;
  ${props => props.$position}: 0;
  background: linear-gradient(
    to ${props => props.$position},
    ${props => transparentize(1, props.theme.color[props.$fadeColor])} 0%,
    ${props => props.theme.color[props.$fadeColor]} 100%
  );
  opacity: ${props => (props.$isVisible ? 1 : 0)};
  transition: opacity ${props => props.theme.transitionTiming};
`;

export const Text = styled.div<{ ref: any }>`
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
  transition: transform 0.1s linear;
`;
